/* ========== Predictive Search (Lumity-style) ========== */
(() => {
  if (window.__psKwArmed) return; window.__psKwArmed = true;

  const CONTENT_SEL = '.header-search .predictive-search__content, .predictive-search__content';
  const INPUT_SEL   = 'input[name="q"]';
  const SLOT_ID     = 'ps-keyword-slot';
  const GRID_CLASS  =  'predictive-search__products grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4';

  const $  = (s, r=document) => r.querySelector(s);

  // --- index ---
  function getIndex(){
    const el = document.getElementById('keyword-index');
    try { return el ? JSON.parse(el.textContent || '{}') : {}; } catch { return {}; }
  }

  // --- small helpers ---
  const rafDebounce = (fn) => {
    let scheduled = false;
    return (...a) => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; fn(...a); });
    };
  };

  function getContent(){ return $(CONTENT_SEL); }
  function getInput(){ return $(INPUT_SEL); }
  function qValue(){ const i = getInput(); return i ? (i.value || '') : ''; }

  function ensureSlot(content){
    let slot = document.getElementById(SLOT_ID);
    if (!slot || !content.contains(slot)){
      slot = document.createElement('div');
      slot.id = SLOT_ID;
      slot.className = GRID_CLASS;
      content.prepend(slot);
    }
    return slot;
  }

  let lastQuery = null;

  // Allow other scripts (like the close handler) to hard-reset the search UI
window.__psKwReset = function __psKwReset() {
  try {
    // Clear input value
    const input = document.querySelector('input[name="q"], [data-predictive-search-input]');
    if (input) input.value = '';

    // Remove our injected results + state
    const content = document.querySelector('.header-search .predictive-search__content, .predictive-search__content');
    if (content) {
      content.classList.remove('ps-has-results');
      const slot = document.getElementById('ps-keyword-slot');
      if (slot) slot.innerHTML = '';
    }

    // Ensure next open starts clean (forces a fresh render)
    lastQuery = null;
  } catch(e) { /* no-op */ }
};


  function render(force=false){
    const content = getContent();
    if (!content) return;

    const q = (qValue() || '').trim().toLowerCase();

    // If our slot doesn't exist (theme re-rendered), force rebuild
    const slotExists = content.contains(document.getElementById(SLOT_ID));
    if (!slotExists) force = true;

    if (!force && q === lastQuery) return; // nothing to do
    lastQuery = q;

    const slot = ensureSlot(content);
    slot.innerHTML = '';
    content.classList.remove('ps-has-results');

    if (!q) return;

    const idx = getIndex();
    let added = 0;
    for (const [handle, it] of Object.entries(idx)){
      if (added >= 12) break;
      const hay = ((it.keywords || '') + ' ' + (it.title || '') + ' ' + handle).toLowerCase();
      if (hay.includes(q)){
        slot.insertAdjacentHTML('beforeend', `
          <div class="predictive-search-result-item ps-added" data-handle="${handle}">
            <a href="${it.url}" class="predictive-search-result-item__link" data-instant>
              <div class="predictive-search-result-item__media">
                <img src="${it.image}" alt="${it.title}" loading="lazy">
              </div>
              <div class="predictive-search-result-item__info">
                <p class="predictive-search-result-item__title">${it.title}</p>
              </div>
            </a>
          </div>
        `);
        added++;
      }
    }
    if (added) content.classList.add('ps-has-results');
  }

  const run = rafDebounce(() => render(false));

  // --- bind to input events (works across drawer re-mounts) ---
  document.addEventListener('input',   e => { if (e.target?.matches(INPUT_SEL)) run(); }, true);
  document.addEventListener('focusin', e => { if (e.target?.matches(INPUT_SEL)) run(); });

  // --- observe predictive container; rebind if theme replaces it ---
  let contentNode = null;
  let contentMO   = null;

  function bindContentObserver(){
    const node = getContent();
    if (!node || node === contentNode) return;

    // disconnect old
    if (contentMO) { try { contentMO.disconnect(); } catch {} }

    contentNode = node;
    contentMO = new MutationObserver(muts => {
      // ignore mutations fully inside our slot to avoid feedback
      const slot = document.getElementById(SLOT_ID);
      const ignore = muts.every(m => {
        if (!slot) return false;
        const inSlot = slot.contains(m.target);
        const allNodesInSlot = [...m.addedNodes, ...m.removedNodes].every(n => n.nodeType === 1 && slot.contains(n));
        return inSlot || allNodesInSlot;
      });
      if (!ignore) {
        // container changed (native redraw) -> force re-render even if query unchanged
        render(true);
      }
    });

    contentMO.observe(node, { childList:true, subtree:true });
    // first paint for the current container
    render(true);
  }

  // watch document for the predictive container appearing/replacing
  const bootstrapMO = new MutationObserver(rafDebounce(bindContentObserver));
  bootstrapMO.observe(document.documentElement, { childList:true, subtree:true });
  // also try immediately (in case already open)
  bindContentObserver();
})();

/* ========== Enter Key Hard Block (no full search page) ========== */
(() => {
  if (window.__psBlockEnterArmed) return; window.__psBlockEnterArmed = true;

  const INPUT_SEL = 'input[name="q"], [data-predictive-search-input]';

  function blockForm(form){
    if (!form || form.__psBlocked) return;
    form.__psBlocked = true;

    const stopSubmit = (e) => { e.preventDefault(); e.stopImmediatePropagation(); return false; };
    form.addEventListener('submit', stopSubmit, true); // capture

    // Neutralise submit buttons
    form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(b => { b.type = 'button'; });

    // Block Enter bubbling via form (themes sometimes bind here)
    ['keydown','keypress','keyup'].forEach(ev => {
      form.addEventListener(ev, (e) => {
        if (e.key === 'Enter') { e.preventDefault(); e.stopImmediatePropagation(); }
      }, true); // capture
    });
  }

  function blockInput(input){
    if (!input || input.__psBlocked) return;
    input.__psBlocked = true;

    // Block Enter on the input itself
    ['keydown','keypress','keyup'].forEach(ev => {
      input.addEventListener(ev, (e) => {
        if (e.key === 'Enter') { e.preventDefault(); e.stopImmediatePropagation(); }
      }, true); // capture
    });

    // Safari <input type="search"> special
    input.addEventListener('search', (e) => { e.preventDefault(); e.stopImmediatePropagation(); }, true);

    blockForm(input.closest('form'));
  }

  function armAll(scope=document){
    scope.querySelectorAll(INPUT_SEL).forEach(blockInput);
    scope.querySelectorAll('form').forEach(f => {
      if (f.querySelector(INPUT_SEL)) blockForm(f);
    });
  }

  // Initial run
  armAll();

  // Re-arm on DOM changes (drawers/predictive swaps)
  if (window.MutationObserver){
    const mo = new MutationObserver(() => armAll());
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

// --- Ensure the "X" close button works ---
(() => {
  const INPUT_SEL = 'input[name="q"], [data-predictive-search-input]';
  const PANEL_SEL = '[data-predictive-search-panel], .predictive-search__content';
  const CLOSE_SEL = '[data-predictive-search-close], .predictive-search__close, .header-search button[type="button"]';

  function getPanel(){ return document.querySelector(PANEL_SEL); }
  function getInput(){ return document.querySelector(INPUT_SEL); }

  function closeSearch() {
  const input = document.querySelector('input[name="q"], [data-predictive-search-input]');

  // Clear input & notify theme listeners
  if (input) {
    input.value = '';
    try { input.dispatchEvent(new Event('input', { bubbles: true })); } catch {}
  }

  // Reset our custom keyword slot/state
  if (window.__psKwReset) window.__psKwReset();

  // Let the theme handle visibility; just drop its open class if it uses one
  document.body.classList.remove('predictive-search--open');
}

  function bindClose(){
    document.querySelectorAll(CLOSE_SEL).forEach(btn => {
      if (btn.__psCloseArmed) return;
      btn.__psCloseArmed = true;
      btn.addEventListener('click', e => {
        e.preventDefault();
        closeSearch();
      });
    });
  }

  // Initial bind + rebind on DOM redraws
  bindClose();
  if (window.MutationObserver){
    const mo = new MutationObserver(bindClose);
    mo.observe(document.documentElement, { childList:true, subtree:true });
  }
})();
